export const GENE_SELECT_OPTIONS = {
  ALL: 'all',
  LIST: 'list',
  CUSTOM: 'custom',
};
